/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Category_StretchingInputs */

const en_us2_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stretching`)
};

const pt_br2_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alongamento`)
};

const es_419_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estiramiento`)
};

const pt_pt2_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alongamento`)
};

const fr_fr2_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étirement`)
};

const de_de2_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dehnen`)
};

const it_it2_exercise_category_stretching = /** @type {(inputs: Exercise_Category_StretchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stretching`)
};

/**
* | output |
* | --- |
* | "Stretching" |
*
* @param {Exercise_Category_StretchingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_category_stretching = /** @type {((inputs?: Exercise_Category_StretchingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Category_StretchingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_category_stretching(inputs)
	if (locale === "es-419") return es_419_exercise_category_stretching(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_category_stretching(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_category_stretching(inputs)
	if (locale === "de-DE") return de_de2_exercise_category_stretching(inputs)
	if (locale === "it-IT") return it_it2_exercise_category_stretching(inputs)
	return en_us2_exercise_category_stretching(inputs)
});
export { exercise_category_stretching as "exercise.category_stretching" }